module.exports = __webpack_public_path__ + "img/effect.75662b5f.png";